export const navDrawerWidth = 120;
export const subNavDrawerWidth = 220;

export const THEMES = {
  LIGHT: "LIGHT",
  DARK: "DARK",
};
